import marquee from "./marquee.vue"

const Marquee = {
  install(Vue) {
    Vue.component("marquee", marquee)
    Vue.prototype.$marquee = async function(data, repeat = 1, speed = 3) {
      try {
        if (!data) return false
        if (speed < 1 || speed > 10) speed = 3
        if (repeat < 1 || repeat > 5) repeat = 1

        const promise = await _$.progress.create()

        const $package = {
          data,
          speed,
          repeat,
          resolve: e => {
            promise.resolve(e)
          },
          reject: e => {
            promise.reject(e)
          }
        }

        _$.vue.$emit("marquee", $package)

        return promise.done
      } catch (err) {
        return _$.error(err)
      }
    }
  }
}

export default Marquee
